import { Component, OnInit } from '@angular/core';
import { StepComponent } from '../step.component';
import { UntypedFormControl } from '@angular/forms';
import { addRateFinderBreadcrumb } from '../../../../../../services/rate-finder-sentry';

@Component({
    selector: 'app-multi-input-step',
    templateUrl: './multi-input-step.component.html',
    styleUrls: ['./multi-input-step.component.scss'],
    standalone: false
})

export class MultiInputStepComponent extends StepComponent implements OnInit {
  controls: Array<UntypedFormControl> = [];

  ngOnInit() {

  }

  submit() {
    for (let control of this.controls) {
      control.markAsTouched();

      if (control.status === 'INVALID') {
        addRateFinderBreadcrumb('validation_failure', { mode: 'form' }, 'warning');
        this.analyticsService.trackQuestionAnsweredInvalid();
        return;
      }
    }

    this.analyticsService.trackQuestionAnswered();

    this.nextStep();
  }

}
